import buildUrl from '../utils/buildUrl';
import { baseUrl } from './baseUrl';

export const getAuthRoute = () => [`${baseUrl.replace('api', 'auth')}`, 'security', 'oauth', 'token'].join('/');

export const forgottenPasswordRoute = (login: string) =>
  buildUrl({
    url: `${baseUrl}/gateway/v1/users/forgot-password`,
    searchParams: { login },
  });

export const resetPasswordRoute = () =>
  buildUrl({
    url: `${baseUrl}/gateway/v1/users/reset-forgotten-password`,
  });

export const publicConfigurationRoute = (tenantId) =>
  buildUrl({
    url: `${baseUrl}/gateway/v1/configurations/public`,
    searchParams: { tenantId },
  });
